// src/templates/AdminLayout.jsx
import { Outlet } from "react-router-dom";
import UserTemplate from "../admin/layout/UserTemplate";

export default function AdminLayout() {
  return (
    <UserTemplate>
      <Outlet />
    </UserTemplate>
  );
}


// import { Outlet } from "react-router-dom";

// export default function UserLayout() {
//   return (
//     <div>
//       <header className="py-4 px-5 border-bottom shadow-sm bg-white sticky-top">
//         <div className="container d-flex justify-content-between align-items-center">
//           {/* <h4 style={{ margin: 0 }}>AlbumFoto</h4> */}
//           <nav>
//             <a href="/" className="mx-3">Home</a>
//             <a href="/about" className="mx-3">Tentang</a>
//             {/* tambahkan menu lainnya */}
//           </nav>
//         </div>
//       </header>

//       <main className="container py-4">
//         <Outlet />
//       </main>

//       <footer className="text-center py-3 bg-light">
//         {/* <small>© {new Date().getFullYear()} AlbumFoto. All rights reserved.</small> */}
//       </footer>
//     </div>
//   );
// }
